<template>

  <v-dialog
    v-model="show"
    persistent
    :max-width="state=='new'?'370':'900'">
    <v-card>
        <v-toolbar color="secondary" dark dense class="mb-3">
              <v-icon left>mdi-account</v-icon> User
            <v-spacer/>
            <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col :cols="state=='new'?'12':'6'">
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                    <v-autocomplete
                      v-model="user.role"
                      :items="roles"
                      dense
                      outlined
                      label="User Role"
                      ></v-autocomplete>   

                      <v-text-field
                      v-model="user.username"
                        label="Username *"
                        :rules="textRules"
                      required
                      dense
                      outlined
                      ></v-text-field>

                    
                      <v-text-field
                        v-model="user.password"
                        v-if="state=='new'" 
                        label="Password *"
                        :rules="textRules"
                        dense
                      outlined
                      required
                      ></v-text-field>

                      <v-text-field
                      v-model="user.fullname"
                        label="Fullname *"
                        :rules="textRules"
                        dense
                      outlined
                      required
                      ></v-text-field>

                        <v-autocomplete
                            v-model="user.assign_code"
                            :items="CODES"
                            dense
                      outlined
                            label="Assignment Route"
                            ></v-autocomplete>   

                            <v-autocomplete
                            dense
                      outlined
                            v-model="user.status"
                            :items="statuses"
                            label="Status"
                            item-text="label"
                            item-value="id"
                            ></v-autocomplete>   

                        <v-text-field
                          v-model="newpassword"
                          name="input-10-1"
                          label="New Password"
                          hint="At least 8 characters"
                          counter
                          dense
                      outlined
                          v-if="show1==true"
                        ></v-text-field>


                      <v-btn block  text v-if="state!='new'" @click="show1=true" small>Change Password</v-btn>
                  </v-form>
                </v-col>

                <v-col cols="6" v-if="state!='new'" >
                  <p class="text-error">*User Permisions</p>
                  <v-row dense class="page-permission">
                    <template v-for="(page, index) in PAGES">
                        <span style="width: 190px;" class="sm-font" :key="index">
                         <v-checkbox v-model="allowed_pages" dense hide-details :label="page.name" :value="page.name" ></v-checkbox>
                        </span>
                    </template>
                  </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    user: {
        type: Object,
        default: ()=>{ return {}}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      allowed_pages:[],
      newpassword:'',
      selected_status:{},
      statuses: [{id:1, label:"Active"}, {id:0, label:"Deactivate"}], 
      show1: false,
      roles: ['superadmin', 'admin', 'officer', 'salesman', 'checker'],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  watch: {
    show (v) {
      if (!v) {
        this.newpassword = ''
        this.show1=false
      } else {
        this.user.password =''
        if(this.state != 'new') {
          this.allowed_pages=this.user.allowed_pages?this.user.allowed_pages:[]
        }
      }
    }
  },
  computed: {
    PAGES(){
      return this.APP_PAGES()
    },
    CODES() {
      var codes = this.$store.state.settings.reduce((res,item)=>{
        if(item.alias == 'codes') {
            res = item.value
        }
        return res
      },'')
      return codes.split(',')
    },
    BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
          this.show1 = false
        }
      },
    emitToParent (action) {
      if(this.show1) {
        this.user.password = this.newpassword
      }
      this.user.status= this.$IsNum(this.user.status)
       this.user.allowed_pages=this.allowed_pages
      this.$emit('DialogEvent', {action: action, user:this.user})
    }
  }
}
</script>
